import { useLocation } from 'react-router-dom';
import { UserOutlineSvg, ShashiLogo } from '../../../icons';

const Header = () => {
  const location = useLocation();
  return (
    <>{location.pathname.includes('shashiunplugged') ? null :
      <header className={`w-[100vw]  flex justify-between items-center  px-4 py-2 shadow-sm bg-white md:mb-6 ${location.pathname.includes('scan-document') || location.pathname.includes('multiple') ? 'fixed top-0' : ''}`}>
        <ShashiLogo />
        {/* {location.pathname.includes('scan-document') || location.pathname.includes('multiple') ? null : <UserOutlineSvg />} */}
      </header>
    }
    </>
  );
}

export default Header